import React from "react";

export const FacebookCircleFilledIcon = (props) => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.818359" width="40" height="40" rx="20" fill="#18428E" />
      <path
        d="M26 10.8184H23C21.6739 10.8184 20.4021 11.3451 19.4645 12.2828C18.5268 13.2205 18 14.4923 18 15.8184V18.8184H15V22.8184H18V30.8184H22V22.8184H25L26 18.8184H22V15.8184C22 15.5531 22.1054 15.2988 22.2929 15.1113C22.4804 14.9237 22.7348 14.8184 23 14.8184H26V10.8184Z"
        fill="white"
      />
    </svg>
  );
};
